import { Container, Stack, Text, Title } from '@mantine/core';

import config from '@/config';

export const Privacy = () => {
  const { product, legalEntity, site, email } = config.brand;

  return (
    <Container py="xl">
      <Stack>
        <Title>Privacy Policy</Title>
        <Title order={2}>1. Definitions</Title>
        <Text>
          This Privacy Policy describes how {legalEntity} collect and process your personal
          information when you interact with company services through the {site} website or
          applications (collectively referred to as {product}). By using {product}, you are agreeing
          to this Privacy Policy.
        </Text>
        <Text></Text>
        <Title order={2}>2. What information we collect and how we use it</Title>
        <Title order={4}>2.1. Information provided by you</Title>
        <Text>
          When you use {product}, we may request and collect personal information from you. This
          information is necessary for us to effectively fulfill any agreements between us, such as
          our Terms of Use. Not providing this information could impact our ability to provide you
          with all the products and features you've requested.
        </Text>
        <Text>2.1.1. Your profile username</Text>
        <Text>
          2.1.2 Your business contacts' usernames with whom you communicate in messengers while
          using our services.
        </Text>
        <Text>2.1.3. Your messages</Text>
        <Title order={4}>2.2. Information collected automatically</Title>
        <Text>
          Below is the information we collect automatically as a result of your use of {product}.
          This information enables us to improve our service.
        </Text>
        <Text>2.2.1. Usage information</Text>
        <Text>
          We collect information about interactions with {product}, including details about the
          pages you visit and instances of service crashes.
        </Text>
        <Text>2.2.2 Device information</Text>
        <Text>
          We collect information from and about the devices you use, such as the hardware model,
          operating system, IP addresses, device settings, mobile device identifiers, installed
          apps, language, battery level, and time zone.
        </Text>
        <Title order={2}>3. Disclosure of information</Title>
        <Text>
          3.1. We share information with our team and contractors to assist with various business
          and technical tasks for you and {product}. They use this information solely to provide
          services for both parties.
        </Text>
        <Text>
          3.2. We share information with trusted third parties like cloud providers and error or log
          monitoring platforms to enhance our products and services for you.
        </Text>
        <Text>
          3.3. We might reveal information to law enforcement, courts, our advisors, and others
          involved in legal proceedings, as required by the law.
        </Text>
        <Title order={2}>4. Security</Title>
        <Text>
          {product} will take reasonable steps to safeguard personal information. We employ a range
          of advanced security technologies and procedures to help prevent unauthorized access, use,
          and disclosure of personal information. For instance, we use encryption when storing or
          transmitting sensitive personal data over the internet. While we strive to secure your
          personal information, we cannot guarantee the safety of any information you transmit to us
          online.
        </Text>
        <Title order={2}>5. Your privacy rights</Title>
        <Text>
          5.1. The right to examine, adjust, or delete personal details we hold about you, as well
          as the ability to grant or withdraw consent for specific uses or sharing of personal
          information.
        </Text>
        <Text>5.2. The right to correct or delete your personal information.</Text>
        <Text>
          5.3. The right to file a complaint with your local data protection authority if you are
          dissatisfied with our handling of your personal information
        </Text>
        <Title order={2}>6. Updates to this policy</Title>
        <Text>
          Our Privacy Policy may be revised. We will inform you of any changes to this Privacy
          Policy, as appropriate, and update the "Last Modified" date at the conclusion of this
          Privacy Policy. Your continued use of {product} signifies your acceptance of our updated
          Privacy Policy. If you disagree with our modified Privacy Policy, you should discontinue
          using {product}. We encourage you to regularly review our Privacy Policy.
        </Text>
        <Title order={2}>6. Ways To Reach us</Title>
        <Text>{email}</Text>
      </Stack>
    </Container>
  );
};
